<div class="page-container">
  @if (permissionService.can_read_service_config$ | async ) {
  @if (!isServiceConfigsLoading) {
  <div class="scroll-container">
    <div class="toolbar">
      <div class="filters">
        <div class="filter-search-bar" [class.active]="serviceFilterSearch">
          <input type="text" placeholder="Search service..." [(ngModel)]="serviceFilterSearch" (ngModelChange)="onServiceSearchChange()" class="service-search-input" />
          @if (serviceFilterSearch) {
            <span class="filter-clear" (click)="clearServiceFilter()">✕</span>
          }
        </div>
        <div class="filter-dropdown" [class.active]="selectedTeamFilter">
          <button type="button" class="filter-trigger" [nxPopoverTriggerFor]="teamFilterPopover" nxPopoverTrigger="click" nxPopoverCloseable="false" #teamFilterTrigger="nxPopoverTrigger" (nxPopoverShowChange)="$event && teamSearchInput.focus()">
            <span>Team{{ selectedTeamFilter ? ': ' + selectedTeamFilter : '' }}</span>
            @if (selectedTeamFilter) {
              <span class="filter-clear" (click)="clearTeamFilter(); $event.stopPropagation()">✕</span>
            } @else {
              <span class="filter-chevron">▾</span>
            }
          </button>
          <nx-popover #teamFilterPopover direction="bottom-start">
            <div class="filter-popover">
              <input type="text" placeholder="Search teams..." [(ngModel)]="teamFilterSearch" class="filter-search" #teamSearchInput />
              <ul class="filter-list">
                @for (team of filteredTeamOptions; track team) {
                  <li class="filter-option" [class.selected]="selectedTeamFilter === team" (click)="onTeamFilterChange(team); teamFilterTrigger.show = false">
                    {{ team }}
                  </li>
                }
                @if (filteredTeamOptions.length === 0) {
                  <li class="filter-empty">No results</li>
                }
              </ul>
            </div>
          </nx-popover>
        </div>
      </div>
      <div class="per-page-select">
        <span>Results per page</span>
        <nx-dropdown [value]="perPage" (valueChange)="onPerPageChange($event)">
          @for (opt of perPageOptions; track opt) {
            <nx-dropdown-item [value]="opt">{{ opt }}</nx-dropdown-item>
          }
        </nx-dropdown>
      </div>
    </div>
    <div class="table-container">
    <div class="table-wrapper" #tableWrapper (scroll)="onTableScroll($event)">
      <table nxTable>
        <thead>
          <tr nxTableRow>
            <th nxHeaderCell class="collapse-column" colspan="2">PagerDuty Service Name</th>
            <th nxHeaderCell>PagerDuty Team Name</th>
            <th nxHeaderCell>Related Service Offering</th>
            <th nxHeaderCell>Related Business Service</th>
            <th nxHeaderCell>Assignment Group</th>
            <th nxHeaderCell>Users Distribution List</th>
            <th nxHeaderCell>JIRA Project</th>
            <th nxHeaderCell>Contact Email</th>
            @if (permissionService.can_write_service_config$ | async) {
            <th nxHeaderCell class="actions-column">Actions</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (serviceConfig of pagedServiceConfigs; track serviceConfig) {
          <tr nxTableRow class="over-effect service-row"
            [class.selected-row]="selectedServiceId === serviceConfig.pagerDutyServiceId"
            (click)="onServiceSelect(serviceConfig)">
            <td nxTableCell class="collapse-column">
              <span class="collapse-icon" [class.expanded]="selectedServiceId === serviceConfig.pagerDutyServiceId">
                ▶
              </span>
            </td>
            <td nxTableCell>{{ serviceConfig.pagerDutyServiceName }}</td>
            <td nxTableCell>{{ serviceConfig.pagerDutyTeamName || serviceConfig.pagerDutyTeamId }}</td>
            <td nxTableCell>{{ serviceConfig.serviceIntegrationManagementServiceOffering }}</td>
            <td nxTableCell>{{ serviceConfig.serviceIntegrationManagementBusinessService }}</td>
            <td nxTableCell>{{ serviceConfig.serviceIntegrationManagementAssignmentGroup }}</td>
            <td nxTableCell class="td-sm">
              <div class="chip-wrapper">
                @if(serviceConfig.emailDistributionList && serviceConfig.emailDistributionList.length > 1){
                <button type="button" [nxPopoverTriggerFor]="emailsListPopover" nxPopoverTrigger="click"
                  class="cell-with-list-button" aria-label="Open email distribution list menu"
                  (click)="onButtonClick(); $event.stopPropagation()">
                  {{ serviceConfig.emailDistributionList[0] }}
                  <span class="popover-list-trigger">
                    <span class="popover-list-trigger-counter">
                      +{{ serviceConfig.emailDistributionList.length - 1 }}
                    </span>
                    ▶
                  </span>
                </button>

                <nx-popover #emailsListPopover direction="bottom-start" (nxOpenedChange)="onPopoverToggle($event)">
                  <div>
                    <ul>
                      @for (emailDistributionitem of serviceConfig.emailDistributionList; track emailDistributionitem) {
                      <li>
                        {{ emailDistributionitem }}
                      </li>
                      }
                    </ul>
                  </div>
                </nx-popover>

                } @else if (serviceConfig.emailDistributionList && serviceConfig.emailDistributionList.length === 1) {
                <span class="cell-with-list-button">
                  {{serviceConfig.emailDistributionList[0]}}
                </span>
                } @else {
                <span class="no-data cell-with-list-button">None</span>
                }
              </div>
            </td>
            <td nxTableCell class="td-sm">{{ serviceConfig.jiraProjectId }}</td>
            <td nxTableCell class="td-sm">{{ serviceConfig.contactEmail }}</td>
            @if (permissionService.can_write_service_config$ | async) {
            <td nxTableCell class="actions-column">
              <button nxButton="secondary small" type="button" class="action-btn edit-button"
                (click)="setCurrentServiceConfig(serviceConfig); $event.stopPropagation()" title="Edit Service">
                Edit
              </button>
            </td>
            }
          </tr>
          @if (selectedServiceId === serviceConfig.pagerDutyServiceId) {
          <tr class="accordion-row">
            <td [attr.colspan]="(permissionService.can_write_service_config$ | async) ? 11 : 10" class="accordion-cell">
              <app-application-table [pagerDutyServiceId]="selectedServiceId"
                (editApplication)="onEditApplication($event)" (createApplication)="onCreateApplication()"
                (deleteApplication)="onDeleteApplication($event)" (createFeature)="onCreateFeature($event)"
                (editFeature)="onEditFeature($event)" (deleteFeature)="onDeleteFeature($event)">
              </app-application-table>
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>
    @if (hasHorizontalOverflow) {
      <div class="scroll-shadow-right"></div>
    }
    </div>
    <div class="bottom-bar">
      <nx-pagination
        [count]="filteredServiceConfigs.length"
        [page]="currentPage"
        [perPage]="perPage"
        type="advanced"
        ariaLabel="Service config pagination"
        (goPage)="onPageChange($event)"
        (goPrev)="onPageChange(currentPage - 1)"
        (goNext)="onPageChange(currentPage + 1)">
      </nx-pagination>
    </div>
  </div>
  }

  @if (isServiceConfigsLoading) {
  <nx-spinner size="large"></nx-spinner>
  }

  <app-service-config-form [serviceConfigId]="currentServiceConfigId"
    (closePanel)="onClosePanel($event)"></app-service-config-form>

  <!-- Application Form handles both create (when applicationId is null) and edit (when applicationId is set) -->
  @if (showApplicationForm) {
  <app-application-form [pagerDutyServiceId]="selectedServiceId" [applicationId]="currentApplicationId"
    (closePanel)="onClosePanel($event)">
  </app-application-form>
  }

  <!-- Feature Form handles both create (when featureId is null) and edit (when featureId is set) -->
  @if (showFeatureForm) {
  <app-feature-form [pagerDutyServiceId]="selectedServiceId" [applicationId]="currentApplicationId"
    [featureId]="currentFeatureId" (closePanel)="onClosePanel($event)">
  </app-feature-form>
  }

  } @else if ((permissionService.can_read_service_config$ | async) === false) {
  <nx-message context="error">
    <span class="nx-font-weight-bold">Error</span><br />
    You don't have access to this application. Please contact your administrator.
  </nx-message>
  } @else {
  <nx-spinner size="large"></nx-spinner>
  }
</div>

<!-- Application Delete Confirmation Modal - Outside page container -->
@if (showApplicationDeleteModal && applicationToDelete) {
<div class="modal-backdrop" (click)="closeApplicationDeleteModal()"></div>
<div class="delete-modal">
  <h3 class="modal-title">Delete Application</h3>
  <p>Are you sure you want to delete the following application?</p>
  <p><strong>{{ applicationToDelete.applicationName }}</strong> (ID: {{ applicationToDelete.applicationId }})</p>
  <p class="warning-text">This action cannot be undone.</p>

  <div class="modal-actions">
    <button nxButton="secondary small" type="button" (click)="closeApplicationDeleteModal()"
      [disabled]="isDeletingApplication">
      Cancel
    </button>
    <button nxButton="destructive small" type="button" class="action-btn delete-btn" type="button"
      (click)="confirmApplicationDelete()" [disabled]="isDeletingApplication">
      @if (isDeletingApplication) {
      <nx-spinner size="small"></nx-spinner>
      }
      Delete
    </button>
  </div>
</div>
}

<!-- Feature Delete Confirmation Modal - Outside page container -->
@if (showFeatureDeleteModal && featureToDelete) {
<div class="modal-backdrop" (click)="closeFeatureDeleteModal()"></div>
<div class="delete-modal">
  <h3 class="modal-title">Delete Feature</h3>
  <p>Are you sure you want to delete the following feature?</p>
  <p><strong>{{ featureToDelete.featureName }}</strong> (ID: {{ featureToDelete.featureId }})</p>
  <p class="warning-text">This action cannot be undone.</p>

  <div class="modal-actions">
    <button nxButton="secondary small" type="button" (click)="closeFeatureDeleteModal()" [disabled]="isDeletingFeature">
      Cancel
    </button>
    <button nxButton="destructive small" type="button" class="action-btn delete-btn" type="button"
      (click)="confirmFeatureDelete()" [disabled]="isDeletingFeature">
      @if (isDeletingFeature) {
      <nx-spinner size="small"></nx-spinner>
      }
      Delete
    </button>
  </div>
</div>
}